import { getPlatformKey } from './utils';
// 用户设备判断
var Device = /* @__PURE__ */ (function () {
    function Device() {
        this._match = function () {
            var ua = window.navigator.userAgent.toLowerCase();
            var ios = /iphone|ipad|ipod/.test(ua);
            var android = /android/.test(ua);
            var mobile = !!ua.match(
            // eslint-disable-next-line max-len
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|MIUI)/i);
            var pc = !mobile;
            var weixin = ua.toLocaleLowerCase().match(/MicroMessenger/i) &&
                ua.toLocaleLowerCase().match(/MicroMessenger/i)[0] === 'micromessenger';
            var qq = !!ua.toLocaleLowerCase().match(/ qq\//i);
            var weixinMini = !!ua.match(/miniProgram/i);
            var weixinMiniPc = !!ua.match(/MiniProgramEnv/i);
            return {
                ios: ios,
                android: android,
                mobile: mobile,
                pc: pc,
                weixin: weixin,
                qq: qq,
                weixinMini: weixinMini,
                weixinMiniPc: weixinMiniPc
            };
        };
        this.match = this._match();
        this.isMobile =
            this._match().mobile || this._match().weixinMini || this._match().weixinMiniPc;
    }
    return Device;
}());
export { Device };
export var getOs = function () {
    var platform = String(navigator.platform);
    if (['Mac68K', 'MacPPC', 'Macintosh', 'MacIntel'].indexOf(platform) !== -1) {
        return 'Mac';
    }
    var isWin = ['Win32', 'Windows'].indexOf(platform) !== -1;
    if (!isWin && platform === 'X11') {
        return 'Unix';
    }
    var userAgent = navigator.userAgent.toLowerCase();
    if (platform.indexOf('Linux') > -1) {
        if (userAgent.indexOf('android') > -1) {
            return 'Android';
        }
        return 'Linux';
    }
    var item;
    var maps = {
        ipad: 'iPad',
        'iphone os': 'iPhone',
        'windows ce': 'wPhone',
        'windows mobile': 'wPhone',
        'windows nt 5.0': 'Windows 2000',
        'windows 2000': 'Windows 2000',
        'windows nt 5.1': 'Windows XP',
        'windows xp': 'Windows XP',
        'windows nt 5.2': 'Windows 2003',
        'windows 2003': 'Windows 2003',
        'windows nt 6.0': 'Windows Vista',
        'windows vista': 'Windows Vista',
        'windows nt 6.1': 'Windows 7',
        'windows 7': 'Windows 7',
        'windows nt 6.2': 'Windows 8',
        'windows 8': 'Windows 8',
        'windows nt 10.0': 'Windows 10',
        windows: 'Windows(Unknown)'
    };
    // eslint-disable-next-line no-restricted-syntax
    for (item in maps) {
        if (userAgent.indexOf(item) > -1) {
            return maps[item];
        }
    }
    return 'Unknown';
};
export var getBrowser = function () {
    var _a;
    var ua = navigator.userAgent;
    var res;
    var bs = [
        /(Chrome\/\d+(\.\d+){2,3}|MSIE \d+.\d+)/gi,
        /(Firefox|Opera|Safari|Camino|Gecko)\/\d+\.\d+/gi
    ];
    var len = bs.length;
    var i = 0;
    for (; i < len; i++) {
        res = ua.match(bs[i]);
        if (res) {
            return res[0].replace(/\s+/gi, '/');
        }
    }
    // IE11：UA 已去掉「MSIE x.x」，但有 Trident；与 EdgeHTML 区分（后者含 Edge/）
    if (/\bTrident\/\d/i.test(ua) && !/\bEdge\//i.test(ua)) {
        var rv = ua.match(/\brv:(\d+\.\d+)/i);
        var ver = (_a = rv === null || rv === void 0 ? void 0 : rv[1]) !== null && _a !== void 0 ? _a : '11.0';
        return "MSIE/".concat(ver);
    }
    return 'Unknown';
};
export var getUa = function () {
    var ua = window.navigator.userAgent;
    var device = new Device();
    var is3387IOSSDK = /3387IOSOperateSDK/.test(ua);
    var is3387Game = /3387Game/.test(ua);
    var is3387SDK = /3387OperateSDK/.test(ua);
    var is3387JSAPPSDK = /3387JsAppSDK/.test(ua);
    var isHykbAndroid = /Androidkb/.test(ua);
    var isHykbIos = /Ioskb/.test(ua);
    var is4399GameBox = /4399GameCenter/.test(ua);
    var is4399SDK = /4399OperateSDK/.test(ua);
    var is4399IosSDK = /4399IosSDK/.test(ua);
    var is4399wan = /4399wan/.test(ua);
    var isWeixinMini = device.match.weixinMini;
    var isWeixinMiniPc = device.match.weixinMiniPc;
    var isWeixin = device.match.weixin;
    return {
        is3387IOSSDK: is3387IOSSDK,
        is3387Game: is3387Game,
        is3387SDK: is3387SDK,
        is3387JSAPPSDK: is3387JSAPPSDK,
        isWeixinMini: isWeixinMini,
        isWeixinMiniPc: isWeixinMiniPc,
        isWeixin: isWeixin,
        isHykbAndroid: isHykbAndroid,
        isHykbIos: isHykbIos,
        is4399GameBox: is4399GameBox,
        is4399SDK: is4399SDK,
        is4399IosSDK: is4399IosSDK,
        is4399wan: is4399wan
    };
};
export var getPlatform = function () {
    var platform_key = getPlatformKey(window.location.pathname.split('/'));
    var isTest = platform_key === 'test';
    var is3387 = platform_key === '3387';
    var is4399IosSyPublish = platform_key === '4399iossypublish';
    var is4399IosSyGamebox = platform_key === '4399iossygamebox';
    var is4399Sy = platform_key === '4399sy';
    var is4399Dj = platform_key === '4399dj';
    var is4399H5 = platform_key === '4399h5';
    var is4399GameBox = platform_key === '4399gamebox';
    var isYxd = platform_key === 'yxd';
    var isHykb = platform_key === 'hykb';
    var is4399Mini = platform_key === 'xcx';
    var is4399Yy = platform_key === '4399yy';
    var isZhkf = platform_key === 'zhkf';
    var isCzkf = platform_key === 'czkf';
    return {
        platform_key: platform_key,
        isTest: isTest,
        is3387: is3387,
        is4399Sy: is4399Sy,
        is4399Dj: is4399Dj,
        is4399H5: is4399H5,
        is4399GameBox: is4399GameBox,
        is4399IosSyPublish: is4399IosSyPublish,
        is4399IosSyGamebox: is4399IosSyGamebox,
        isYxd: isYxd,
        isHykb: isHykb,
        is4399Mini: is4399Mini,
        is4399Yy: is4399Yy,
        isZhkf: isZhkf,
        isCzkf: isCzkf
    };
};
// 开发环境
var NODE_ENV = process.env.NODE_ENV;
export var isDev = ['development'].includes(NODE_ENV);
// 自主测试环境
export var isTest1 = NODE_ENV === 'test1';
// 流程测试
export var isTest2 = NODE_ENV === 'test2';
// ot测试
export var isOt = NODE_ENV === 'ot';
// 生产环境
export var isProd = NODE_ENV === 'production';
export var getSSOUrl = function () {
    if (isTest1 || isTest2)
        return '/chat/chat/home/im/login-auth';
    if (isOt)
        return '/chat/chat/home/im/login-auth';
    return 'https://u.4399.com/sso/kefu-auth.html';
};
export var getYxdSSOUrl = function () {
    if (isTest1 || isTest2)
        return 'http://t2.youxidian.com/service/sso/kefu/auth';
    if (isOt)
        return "".concat(window.location.origin, "/service/sso/kefu/auth");
    return "".concat(window.location.origin, "/service/sso/kefu/auth");
};
